import axiosClient from "../utils/axiosClient";

export const fetchInitialData = ()=> axiosClient.get('/getPreDefinedData')